import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import {
	type SubstitutionPlanContactNotificationListSchema,
	type SubstitutionPlanFrontendFormSchema,
	substitutionPlanContactNotificationListSchema,
} from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { SubstitutionPlanContactForm } from "@/forms/substitution-plan-contact-form";
import { SubstitutionPlanContactModalContext } from "./context";

/** Props Interface */
interface SubstitutionPlanContactModalProps extends ModalProps {
	projectId: string;
	defaultValues: SubstitutionPlanFrontendFormSchema["items"][number]["contactNotifications"];
	substitutionPlanProjectItemId: string;
	onComplete: (json: SubstitutionPlanContactNotificationListSchema) => void;
}

export function SubstitutionPlanContactModal({
	isOpen,
	onClose,
	projectId,
	defaultValues,
	substitutionPlanProjectItemId,
	onComplete,
}: SubstitutionPlanContactModalProps) {
	/** Hooks */
	const methods = useForm({
		resolver: resolver(substitutionPlanContactNotificationListSchema),
		defaultValues: async () => {
			return {
				items: defaultValues,
			};
		},
	});
	const { t } = useTranslation();

	/** Functions */
	async function handleOnSubmit(json: SubstitutionPlanContactNotificationListSchema) {
		onComplete(json);
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<SubstitutionPlanContactModalContext.Provider value={{ substitutionPlanProjectItemId }}>
				<Modal
					isOpen={isOpen}
					onClose={onClose}
					title={t("substitutions.notify_contacts")}
					width="85vw"
					onSubmit={methods.handleSubmit(handleOnSubmit)}
				>
					<Modal.Body>
						<SubstitutionPlanContactForm projectId={projectId} />
					</Modal.Body>
					<Modal.FooterForm />
				</Modal>
			</SubstitutionPlanContactModalContext.Provider>
		</FormProvider>
	);
}
